import React from 'react';
import SimpleModal from 'ui/Modals/SimpleModal';
import { HrSimulation } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import { FreeHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/FreeHypothesis/helpers/types';
import { useGetHrGVTData } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/GVTData/helpers/hooks/gvtData';
import FreeHypothesesListView from './components/informationDisplay/FreeHypothesisListView';
import { useTranslation } from 'react-i18next';

type Props = {
    hrSimulation: HrSimulation;
    showModal: boolean;
    setShowModal: (arg: boolean) => void;
    freeHypotheses: FreeHypothesis[];
};

export default function FreeHypothesisListModal({
    hrSimulation,
    showModal,
    setShowModal,
    freeHypotheses,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const { data: gvtDataResponse, isLoading: isDataLoading } = useGetHrGVTData(
        hrSimulation.id,
    );
    const { freeHypothesisTotals = {} } = gvtDataResponse ?? {};

    return (
        <SimpleModal
            open={showModal}
            onClose={() => setShowModal(false)}
            maxWidth="xl"
            dialogTitle={t(
                'humanResources.simulation.freeHypothesis.hypothesisType_other',
                { type: 'IFSE' },
            )}
        >
            <FreeHypothesesListView
                freeHypothesisData={freeHypotheses}
                freeHypothesisTotals={freeHypothesisTotals}
                editMode={false}
                isLoading={isDataLoading}
            />
        </SimpleModal>
    );
}
